"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "tooltip": "au_tooltip-module__tooltip___ZqBU2",
  "error": "au_tooltip-module__error___lnGR5 au_tooltip-module__tooltip___ZqBU2",
  "arrow": "au_tooltip-module__arrow___CjEya",
  "info": "au_tooltip-module__info___VeZUe au_tooltip-module__tooltip___ZqBU2",
  "title": "au_tooltip-module__title___MYmHX"
};
const POSITION_BOTTOM = 'bottom';
const POSITION_TOP = 'top';
const POSITION_LEFT = 'left';
const POSITION_RIGHT = 'right';
const EFFECT_SOLID = 'solid';
const EFFECT_FLOAT = 'float';
const TYPE_ERROR = 'error';
const TYPE_INFO = 'info';
class AuTooltip extends _react.default.PureComponent {
  static positions = [POSITION_BOTTOM, POSITION_TOP, POSITION_LEFT, POSITION_RIGHT];
  static effects = [EFFECT_SOLID, EFFECT_FLOAT];
  static types = [TYPE_ERROR, TYPE_INFO];
  static propTypes = {
    id: T.string.isRequired,
    title: T.oneOfType([T.string, T.element]),
    type: T.oneOf(AuTooltip.types).isRequired,
    position: T.oneOf(AuTooltip.positions),
    effect: T.oneOf(AuTooltip.effects),
    className: T.string,
    titleClassName: T.string
  };
  static defaultProps = {
    position: POSITION_TOP,
    effect: EFFECT_SOLID
  };
  render() {
    const {
      id,
      type,
      title,
      position,
      effect,
      className,
      titleClassName,
      children
    } = this.props;
    const classes = (0, _classnames.default)(styles[type], className);
    const hasTitle = Boolean(title);
    return /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
      id: id,
      place: position,
      className: classes,
      isCapture: true,
      effect: effect,
      type: "light"
    }, hasTitle && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.title, titleClassName)
    }, title), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.content
    }, children), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.arrow
    }));
  }
}
exports.default = AuTooltip;